import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import * as _ from 'lodash';

import { FieldEnum } from 'Common/FieldEnum';
import { StyledReduxFormError } from '../../';
import { InputField } from 'Common/SemanticWrapper';
import { Form } from 'semantic-ui-react';

class BasicSetupForm extends Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.valid !== this.props.valid) {
      this.props.setIsValid(nextProps.valid);
    }
  }

  renderId(canEdit) {
    if (canEdit) {
      return (
        <Field
          name={FieldEnum.Id}
          component={InputField}
          type="text"
          maxLength={2}
          autoFocus={true}
          label={'Id'}
        />
      );
    } else {
      return <Field name={FieldEnum.Id} component="input" type="hidden" />;
    }
  }

  render() {
    const { handleSubmit, error, canEditId } = this.props;

    return (
      <div>
        <Form onSubmit={handleSubmit}>
          {this.renderId(canEditId)}
          <Field
            name={FieldEnum.Description}
            component={InputField}
            type="text"
            maxLength={30}
            autoFocus={canEditId ? false : true}
            label={'Description'}
          />
          <StyledReduxFormError error={error} />
        </Form>
      </div>
    );
  }
}

const validate = (values, props) => {
  const errors = {};

  if (
    !values[FieldEnum.Description] ||
    _.trim(values[FieldEnum.Description]).length === 0
  ) {
    errors[FieldEnum.Description] = 'Description Required';
  }

  const isData = _.find(props.basicSetup, {
    Description: values[FieldEnum.Description],
  });
  if (isData) {
    errors[FieldEnum.Description] = props.humanname + ' already exits';
  }

  if (props.canEditId) {
    if (!values[FieldEnum.Id] || _.trim(values[FieldEnum.Id]).length === 0) {
      errors[FieldEnum.Id] = 'Id Required';
    }
  }

  return errors;
};

export default reduxForm({
  validate,
  form: 'BasicSetupForm',
})(BasicSetupForm);



// WEBPACK FOOTER //
// ./src/components/basicsetup/components/BasicSetupForm.js